/*
 * @Author: Merlin
 * @Date: 2024-01-30 10:46:04
 * @LastEditors: Merlin
 * @LastEditTime: 2024-02-29 19:12:59
 * @Description: 
 */

import { useAmountMemoryStore } from "~/stores/cansino/amountMemory";

interface BetForm {
    amount: number;
    isFast: boolean;
    frontID: number;
    number: number;
    type: number;
    
}


export const useRouleeteSocket = (rootPath = 'games') => {
    const EMIT_ROULETTE_BET = async (data: BetForm) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        const res = await asyncEmit(
            `${rootPath}.roulette.bet`, 
            {...data},
        );
        return res;
    };
    
    return {
        EMIT_ROULETTE_BET
    };
};

